import { NO_DESCRIPTION_AVAILABLE } from '@constants';

export const fetchIncidentDescription = async (
    id: string
): Promise<string | undefined> => {
    try {
        const response = await fetch(
            `https://sind-api.herokuapp.com/mapaction/v2/healthEventDescription?id=${id}`
        );

        if (!response.ok) {
            console.error(`API error: ${response.status}`);
            return;
        }

        const jsonResponse = await response.json();
        const eventDescription = jsonResponse?.de?.trim();
        return eventDescription;
    } catch (error) {
        console.error('Failed to fetch description:', error);
        return;
    }
};

export async function getIncidentDescription(id: string): Promise<string> {
    const description = await fetchIncidentDescription(id);
    return description
        ? `${description} (ID: ${id})`
        : `${NO_DESCRIPTION_AVAILABLE} (ID: ${id})`;
}
